import { PracticeRow, StudentCard } from '@athena/ui'
import { createLink } from '@tanstack/react-router'

/**
 * The entity-link molecules, wrapped as router links.
 *
 * `createLink` is TanStack Router's way of turning a ref-forwarding anchor
 * component into a typed `Link`: `to` and `params` are checked against the
 * route tree, and navigation stays client-side. The design system stays
 * unaware that a router exists.
 */
export const PracticeRowLink = createLink(PracticeRow)
export const StudentCardLink = createLink(StudentCard)
